<template>
  <div>
    <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">Acuerdo CORE</h2>
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Descripción acuerdo *">
            <editor-text
              :danger="errors.has('custom-document.description')"
              :danger-text="errors.first('custom-document.description')"
              data-cy="description"
              data-vv-as="descripción"
              :max-length="maxLengthDescription"
              name="description"
              ref="description"
              v-validate="'required'"
              v-model="formData.description"
              with-counter
            />
          </b-form-group>
        </div>
        <div class="col-md-3 mt-2">
          <b-form-group label="Fecha de documento *">
            <date-picker
              data-cy="document-date"
              class="w-100"
              name="documentDate"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              data-vv-as="fecha de documento"
              :danger="errors.has('custom-document.documentDate')"
              :danger-text="errors.first('custom-document.documentDate')"
              v-validate="'required'"
              v-model="formData.documentDate"
            />
            <div v-if="errors.has('custom-document.documentDate')">
              <small class="text-danger">
                {{ errors.first('custom-document.documentDate') }}
              </small>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 mt-2">
          Orientación de documento
          <div class="row mt-3">
            <div class="col-md-4">
              <vs-radio
                vs-name="portrait"
                vs-value="Portrait"
                v-model="formData.orientation"
                data-cy="portrait"
              >
                Vertical
              </vs-radio>
            </div>
            <div class="col-md-4">
              <vs-radio
                vs-name="landscape"
                vs-value="Landscape"
                v-model="formData.orientation"
                data-cy="landscape"
              >
                Horizontal
              </vs-radio>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center mt-5">
        <div class="col-md-12">
          <label>Adjuntos</label>
        </div>
        <div class="col-md-3 align-items-end">
          <upload-file
            permission="*"
            accept="application/pdf, .doc, .docx, .xlsv, .ppt"
            text="Seleccionar documentos"
            v-model="file"
            upload-to="ed"
            :button-class="{ 'btn-block': true, 'mb-5': errors.has('custom-document.fileName') }"
            container-class="w-100"
            @input="addFile()"
          />
        </div>
      </div>
      <div class="row align-items-center mt-1">
        <div class="col-md-3 align-items-end">
          <b-button
            variant="secondary"
            class="btn-icon mt-1"
            data-cy= "from-repository"
            v-has-permission="'ED060'"
            v-b-modal="'add-file-repository'"
          >
            <feather-icon icon="ServerIcon"/>
            Desde el repositorio
          </b-button>
        </div>
        <div class="col-2" v-for="file in formData.files" :key="file.id">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="25px" color="primary" />
            <b class="text-truncate w-100 text-center">{{ file.name }}</b>
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="removeFile(file.id)"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!!error.message"
        class="con-text-validation span-text-validation-danger
              vs-input--text-validation-span v-enter-to text-right"
      >
        <span class="span-text-validation">
          {{ error.message }}
        </span>
      </div>
    </form>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="back()"
        color="primary"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
        :disabled="saving"
      >
        Crear
        <span
          v-show="saving"
          class="spinner-border spinner-border-sm text-primary"
        />
      </vs-button>
    </div>
    <!--<SelectDocRepository
      :add-file="addFileRepo"
      :files="formData.files"
      :remove-file="removeFile"
    />-->
    <repository-selector
      modal-id="add-file-repository"
      :add-file="addFileRepo"
      :files="formData.files"
      :remove-file="removeFile"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import EditorText from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/EditorText';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import SelectDocRepository
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';
import RepositorySelector from "@/febos/global/customDocuments/components/repository-selector/RepositorySelector.vue";

export default {
  name: 'ACUCORE',
  components: {
    RepositorySelector,
    EditorText, UploadFile, DatePicker, SelectDocRepository
  },
  data() {
    return {
      formData: {
        description: '',
        orientation: 'Portrait',
        files: [],
        documentDate: this.$moment().format('YYYY-MM-DD')
      },
      maxLengthDescription: 10000,
      saving: false,
      file: {},
      error: {
        message: ''
      }
    };
  },
  methods: {
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    removeFile(id) {
      this.formData.files = this.formData.files.filter((file) => file.id !== id);
    },
    async addFile() {
      if (!Object.keys(this.file).length) {
        return;
      }

      if (this.file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.formData.files.push(this.file);
      this.error.message = '';
    },
    async addFileRepo(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.formData.files.push(file);
      this.error.message = '';
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('ACUCORE', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      this.back();
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async save() {
      const isValid = await this.validateForm('custom-document');
      if (!isValid) {
        return;
      }

      const textPlainDescription = this.$refs.description.getTextPlain();
      if (textPlainDescription.length > this.maxLengthDescription) {
        this.$bvToast.toast(
          'El campo descripción tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }

      this.error.message = '';
      this.saving = true;

      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: this.$route.query,
          formData: {
            ...this.formData,
            ...(!!this.formData.files.length
              && { attachments: this.formData.files }),
            metadata: { orientation: this.formData.orientation }
          },
        };
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
